import { Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';
import { CommodityCondition } from 'store/commodity-conditions-center/commodityCondition';

type Props = {
    condition: CommodityCondition | null;
    onCancel: () => void;
    onConfirm: () => void;
};

const DeleteCommodityConditionModal = ({ condition, onCancel, onConfirm }: Props) => (
    <ConfirmationModal
        width={500}
        open={condition !== null}
        type="error"
        icon={<DeleteOutlined />}
        title="Delete Commodity Condition?"
        confirmButtonText="Delete"
        onConfirm={onConfirm}
        onCancel={onCancel}
        content={
            <Typography.Text>
                The mapping for commodity code {condition?.commodityCode}, TARIC code {condition?.taricCode} and country
                of origin {condition?.countryOrigin} will be permanently deleted.
            </Typography.Text>
        }
    />
);

export default DeleteCommodityConditionModal;
